/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ConnectivityStatus } from './ConnectivityStatus';
import {
    ConnectivityStatusFromJSON,
    ConnectivityStatusFromJSONTyped,
    ConnectivityStatusToJSON,
    ConnectivityStatusToJSONTyped,
} from './ConnectivityStatus';
import type { AssetSummarySiteResponseDto } from './AssetSummarySiteResponseDto';
import {
    AssetSummarySiteResponseDtoFromJSON,
    AssetSummarySiteResponseDtoFromJSONTyped,
    AssetSummarySiteResponseDtoToJSON,
    AssetSummarySiteResponseDtoToJSONTyped,
} from './AssetSummarySiteResponseDto';
import type { AssetSummaryLookupResponseDto } from './AssetSummaryLookupResponseDto';
import {
    AssetSummaryLookupResponseDtoFromJSON,
    AssetSummaryLookupResponseDtoFromJSONTyped,
    AssetSummaryLookupResponseDtoToJSON,
    AssetSummaryLookupResponseDtoToJSONTyped,
} from './AssetSummaryLookupResponseDto';

/**
 * 
 * @export
 * @interface GetAssetSummaryResponseDto
 */
export interface GetAssetSummaryResponseDto {
    /**
     * 
     * @type {string}
     * @memberof GetAssetSummaryResponseDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof GetAssetSummaryResponseDto
     */
    organizationId: string;
    /**
     * 
     * @type {string}
     * @memberof GetAssetSummaryResponseDto
     */
    assetName: string;
    /**
     * 
     * @type {string}
     * @memberof GetAssetSummaryResponseDto
     */
    serialNumber: string;
    /**
     * 
     * @type {AssetSummaryLookupResponseDto}
     * @memberof GetAssetSummaryResponseDto
     */
    assetType: AssetSummaryLookupResponseDto;
    /**
     * 
     * @type {AssetSummaryLookupResponseDto}
     * @memberof GetAssetSummaryResponseDto
     */
    assetModel: AssetSummaryLookupResponseDto | null;
    /**
     * 
     * @type {ConnectivityStatus}
     * @memberof GetAssetSummaryResponseDto
     */
    connectivityStatus: ConnectivityStatus | null;
    /**
     * 
     * @type {Date}
     * @memberof GetAssetSummaryResponseDto
     */
    lastSeenAt: Date | null;
    /**
     * 
     * @type {AssetSummarySiteResponseDto}
     * @memberof GetAssetSummaryResponseDto
     */
    site: AssetSummarySiteResponseDto;
}



/**
 * Check if a given object implements the GetAssetSummaryResponseDto interface.
 */
export function instanceOfGetAssetSummaryResponseDto(value: object): value is GetAssetSummaryResponseDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('organizationId' in value) || value['organizationId'] === undefined) return false;
    if (!('assetName' in value) || value['assetName'] === undefined) return false;
    if (!('serialNumber' in value) || value['serialNumber'] === undefined) return false;
    if (!('assetType' in value) || value['assetType'] === undefined) return false;
    if (!('assetModel' in value) || value['assetModel'] === undefined) return false;
    if (!('connectivityStatus' in value) || value['connectivityStatus'] === undefined) return false;
    if (!('lastSeenAt' in value) || value['lastSeenAt'] === undefined) return false;
    if (!('site' in value) || value['site'] === undefined) return false;
    return true;
}

export function GetAssetSummaryResponseDtoFromJSON(json: any): GetAssetSummaryResponseDto {
    return GetAssetSummaryResponseDtoFromJSONTyped(json, false);
}

export function GetAssetSummaryResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetAssetSummaryResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'organizationId': json['organizationId'],
        'assetName': json['assetName'],
        'serialNumber': json['serialNumber'],
        'assetType': AssetSummaryLookupResponseDtoFromJSON(json['assetType']),
        'assetModel': AssetSummaryLookupResponseDtoFromJSON(json['assetModel']),
        'connectivityStatus': ConnectivityStatusFromJSON(json['connectivityStatus']),
        'lastSeenAt': (json['lastSeenAt'] == null ? null : new Date(json['lastSeenAt'])),
        'site': AssetSummarySiteResponseDtoFromJSON(json['site']),
    };
}

export function GetAssetSummaryResponseDtoToJSON(json: any): GetAssetSummaryResponseDto {
    return GetAssetSummaryResponseDtoToJSONTyped(json, false);
}

export function GetAssetSummaryResponseDtoToJSONTyped(value?: GetAssetSummaryResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'organizationId': value['organizationId'],
        'assetName': value['assetName'],
        'serialNumber': value['serialNumber'],
        'assetType': AssetSummaryLookupResponseDtoToJSON(value['assetType']),
        'assetModel': AssetSummaryLookupResponseDtoToJSON(value['assetModel']),
        'connectivityStatus': ConnectivityStatusToJSON(value['connectivityStatus']),
        'lastSeenAt': value['lastSeenAt'] == null ? value['lastSeenAt'] : value['lastSeenAt'].toISOString(),
        'site': AssetSummarySiteResponseDtoToJSON(value['site']),
    };
}

